module.exports = __webpack_public_path__ + "img/geofisica_4-3_1024.ed4e5a26.webp";